var _effectorFileName = "/builds/gmini/front-chm-api-sdk/src/domain.ts";
import { root } from 'effector-root';
export var ApiDomain = root.domain('API', {
  name: "ApiDomain",
  sid: "-8b1hk1"
});